import CalendarLogo from "@/assets/image/icons/menu/icon-menu_agenda.svg?inline";
import ActivityLogo from "@/assets/image/icons/menu/icon-menu_activities.svg?inline";
import NewsLogo from "@/assets/image/icons/menu/icon-menu_news.svg?inline";
import ProfileLogo from "@/assets/image/icons/menu/icon-menu_profile.svg?inline";
import LogoutLogo from "@/assets/image/icons/menu/icon-menu_logout.svg?inline";
import MobileCollapseLogo from "@/assets/image/icons/menu/icon-mobile_menu.svg?inline";

export default {
    components: { CalendarLogo, ActivityLogo, NewsLogo, ProfileLogo, LogoutLogo, MobileCollapseLogo }
}